import { AuthService } from "../shared/services/AuthService.js";
import { AppConfig } from "../shared/utils/AppConfig.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { ApiService } from "../shared/utils/ApiService.js";
import { escapeHtml } from "../shared/utils/sanitize.js";

import loginTemplate from "./templates/login.html?raw";
import forgotTemplate from "./templates/forgot-password.html?raw";
import activateTemplate from "./templates/activate.html?raw";
import Swal from "sweetalert2";

export const AuthController = {
  renderLogin: () => {
    const externo = AuthService.isExterno();
    const errorIngreso = externo ? AuthService.tomarErrorIngreso() : null;
    const data = {
      logoUrl: "/logo.png",
      appName: AppConfig.app.name,
      externo,
      externoLabel: escapeHtml(AppConfig.auth.label),
      errorIngreso: errorIngreso
        ? `<div class="alert alert-danger small" role="alert"><i class="fas fa-circle-exclamation me-2"></i>${escapeHtml(errorIngreso)}</div>`
        : "",
    };

    document.getElementById("app").innerHTML = TemplateEngine.render(loginTemplate, data);
    if (externo) {
      document.getElementById("btnIngresoExterno").addEventListener("click", () => AuthService.irAIngresoExterno());
      return;
    }
    document.getElementById("loginForm").addEventListener("submit", AuthController.handleLogin);

    const toggleBtn = document.getElementById("toggle-password");
    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        const input = document.getElementById("password");
        const icon = toggleBtn.querySelector("i");
        const show = input.type === "password";
        input.type = show ? "text" : "password";
        icon.classList.toggle("fa-eye", !show);
        icon.classList.toggle("fa-eye-slash", show);
      });
    }
  },

  renderForgotPassword: () => {
    document.getElementById("app").innerHTML = TemplateEngine.render(forgotTemplate, {
      logoUrl: "/logo.png",
      appName: AppConfig.app.name,
    });
    document.getElementById("forgotForm")?.addEventListener("submit", AuthController.handleForgot);
  },

  handleForgot: async(e) => {
    e.preventDefault();
    const email = document.getElementById("email").value.trim();
    const loading = document.querySelector(".loading");
    loading?.classList.add("show");
    try {
      await ApiService.post("auth/forgot", { email });
      await Swal.fire({
        icon: "success",
        title: "Revisa tu email",
        text: "Si existe una cuenta con ese email, recibirás las instrucciones en breve.",
        confirmButtonText: "Volver al login",
      });
      window.location.hash = "login";
    } catch {
      Swal.fire("Error", "No se pudo enviar el email. Intentá de nuevo.", "error");
    } finally {
      loading?.classList.remove("show");
    }
  },

  renderSetPassword: (params) => {
    const token = params?.get("token") || "";
    document.getElementById("app").innerHTML = TemplateEngine.render(activateTemplate, {
      logoUrl: "/logo.png",
      appName: AppConfig.app.name,
      secTkn: token,
    });
    document.getElementById("activateForm")?.addEventListener("submit", AuthController.handleSetPassword);
  },

  handleSetPassword: async(e) => {
    e.preventDefault();
    const token = document.getElementById("secTkn").value;
    const password = document.getElementById("password").value;
    const confirm = document.getElementById("confirmPassword").value;
    if (password !== confirm) {
      Swal.fire("Error", "Las contraseñas no coinciden", "error");
      return;
    }
    if (password.length < 6) {
      Swal.fire("Error", "La contraseña debe tener al menos 6 caracteres", "error");
      return;
    }
    const loading = document.querySelector(".loading");
    loading?.classList.add("show");
    try {
      await ApiService.post("auth/reset", { token, password });
      await Swal.fire({
        icon: "success",
        title: "Contraseña establecida",
        text: "Ya podés iniciar sesión con tu nueva contraseña.",
        confirmButtonText: "Iniciar sesión",
      });
      window.location.hash = "login";
    } catch (err) {
      Swal.fire("Error", err.message || "El enlace es inválido o ya expiró.", "error");
    } finally {
      loading?.classList.remove("show");
    }
  },

  handleLogin: async(e) => {
    e.preventDefault();
    const loading = document.querySelector(".loading");
    loading?.classList.add("show");
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    try {
      const result = await AuthService.login(email, password);
      if (result.success) {
        window.location.hash = "dashboard";
        window.location.reload();
      } else {
        Swal.fire("Error", result.message, "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Error al autenticar", "error");
    } finally {
      loading?.classList.remove("show");
    }
  },
};
